const API_URL = "https://www.manglamgold.com/csadmin/api"
//const API_URL =   "https://codexo.in/2023/chokhidhanifoods/csadmin/api/"
// const BASE_URL =   "https://balhath.com/"    
const FRONT_URL =   "https://www.manglamgold.com/"    
const DEFAULT_IMAGE = "/img/defaultimage.jpg";
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting,FRONT_URL,DEFAULT_IMAGE };